export const ReportTypes = [
    { value: '1', label: 'Problem in Applying for the job' },
    { value: '2', label: 'Fradulent' },
    { value: '6', label: 'Company demanded money' },
    { value: '3', label: 'Invalid data/ Texual mistake' },
    { value: '4', label: 'Offensive / Misleading' },
    { value: '5', label: 'Other' }
]

